
import { Trip } from "@/types/itinerary";
import { useEventsFetcher } from "./itinerary/useEventsFetcher";
import { useTripDays } from "./itinerary/useTripDays";

/**
 * Main hook for itinerary events management
 * Combines event fetching and trip days calculation
 */
export const useItineraryEvents = (trip: Trip | null) => {
  const { events, setEvents, isLoading, fetchEvents } = useEventsFetcher(trip);
  const tripDays = useTripDays(trip);
  
  return { 
    events, 
    setEvents, 
    isLoading,
    tripDays,
    refreshEvents: fetchEvents
  };
};
